export const environment = {
    production: true,
    APP_MALOU_API_URL: 'https://development.api.malou.io',
    GOOGLE_FRONTEND_KEY: 'AIzaSyD5FybD7Ta7vdHbdn7uZ7QqHqjx5ndLYOQ',
    HUBSPOT: {
        region: 'eu1',
        portalId: '25820972',
        formIdFr: 'a7fb7c80-2cf4-4a0d-b402-1d2563a15eb9',
        formIdEn: 'c10be412-7db2-4637-bea6-6cf6e9c12bb8',
    },
};
